import graphqlHelperService from "./graphqlHelper.service";
import { CourseProgressUrl, UserInformation } from "../types/userInformation";

export const userInformationService = {
    userInformation: async (): Promise<UserInformation> => {
        const apolloResult = await graphqlHelperService.sendQuery(
            userInformationQuery()
        );
        return apolloResult.userInformation as UserInformation;
    },
    courseProgressUrl: async (): Promise<CourseProgressUrl> => {
        const apolloResult = await graphqlHelperService.sendQuery(
            courseProgressUrlQuery
        );
        return apolloResult.courseProgressUrl as CourseProgressUrl;
    },
    requestEdit: async (userInformation: UserInformation): Promise<UserInformation> => {
        const apolloResult = await graphqlHelperService.sendMutate(
            requestEditQuery,
            { userInformation: buildUserInformationInput(userInformation) }
        );
        return apolloResult.userInformation as UserInformation;
    },
};

const courseProgressUrlQuery = `query{
    courseProgressUrl {
        url
        active
    }
}`

const requestEditQuery = `mutation EditRequest($userInformation: UserInformationInput!) {
    editRequest (
        userInformation: $userInformation
    )
}`

// Falsy strings become undefined so the field is omitted from the JSON.
const opt = (value?: string): string | undefined => value ? value : undefined;

const buildUserInformationInput = (userInformation: UserInformation) => ({
    student: userInformation.student ? {
        studentId: opt(userInformation.student.studentId),
        sex: userInformation.student.sex,
        initials: userInformation.student.initials,
        firstName: opt(userInformation.student.firstName),
        prefix: opt(userInformation.student.prefix),
        lastName: userInformation.student.lastName,
        address: userInformation.student.address,
        houseNumber: userInformation.student.houseNumber,
        zipCode: userInformation.student.zipCode,
        place: userInformation.student.place,
        birthDate: userInformation.student.birthDate,
        birthPlace: userInformation.student.birthPlace,
        privateNumber: opt(userInformation.student.privateNumber),
        mobileNumber: userInformation.student.mobileNumber,
        email: userInformation.student.email,
    } : undefined,
    relation: userInformation.relation ? {
        sex: userInformation.relation.sex,
        initials: userInformation.relation.initials,
        firstName: opt(userInformation.relation.firstName),
        prefix: opt(userInformation.relation.prefix),
        lastName: userInformation.relation.lastName,
        address: userInformation.relation.address,
        houseNumber: userInformation.relation.houseNumber,
        zipCode: userInformation.relation.zipCode,
        place: userInformation.relation.place,
        workNumber: userInformation.relation.workNumber,
        mobileNumber: opt(userInformation.relation.mobileNumber),
        email: userInformation.relation.email,
        contactEmail: opt(userInformation.relation.contactEmail),
        companyName: opt(userInformation.relation.companyName),
        invoiceEmail: opt(userInformation.relation.invoiceEmail),
        byMail: !!userInformation.relation.byMail,
        ...(userInformation.relation.byMail ? {
            invoiceAddress: userInformation.relation.invoiceAddress,
            invoiceHouseNumber: userInformation.relation.invoiceHouseNumber,
            invoiceZipCode: userInformation.relation.invoiceZipCode,
            invoicePlace: userInformation.relation.invoicePlace,
        } : {}),
    } : undefined,
});

const userInformationQuery = () => `query{
userInformation{
    student {
            sex
            initials
            firstName
            prefix
            lastName
            address
            houseNumber
            zipCode
            place
            birthDate
            birthPlace
            privateNumber
            mobileNumber
            email
            courseResults {
                name
                date
                passed
                failed
                grade
                place
                madeSampleExams
                sampleExamGrade
            }
        }
        relation {
            sex
            initials
            firstName
            prefix
            lastName
            address
            houseNumber
            zipCode
            place
            workNumber
            mobileNumber
            email
            contactEmail
            companyName
            invoiceAddress
            invoiceHouseNumber
            invoiceZipCode
            invoicePlace
            invoiceEmail
            byMail
            khnId
        }
    }
}`
